import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export const PosView = angular
  .module('acme.view.application.pos', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.pos.controllers',
    'acme.view.application.pos.deleteModal.controllers',
    'acme.view.application.pos.list',
    'acme.view.application.pos.create',
    'acme.view.application.dataGrid.controllers',
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const pos = {
      name: 'application.pos',
      url: '/pos',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'PosController',
          templateUrl: 'views/application/views/pos/pos.tpl.html',
        },
      },
      data: {
        pageTitle: 'POS Configuration',
        permissions: ['POS_CONFIG_VIEW'],
      },
    };

    $stateProvider.state(pos);
  }).name;
